module.exports = __webpack_public_path__ + "static/media/goats-350.c2c49b70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SlideShow/goats-350.jpg
// module id = 1432
// module chunks = 0